import Debug from 'debug';
import { LitElement, nothing, PropertyValues } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Subscription } from 'rxjs';
import { dataBroker } from '../services/DataBroker';
import { ITreeNode, Tree } from './tree/common';

let nextTreeId = 0
const log = Debug('pdq:flow:pdq-tree');
@customElement('pdq-tree')
export class PdqTree extends LitElement {
  static styles = []
  @property({type: String})
  id: string = 'pdq-tree-' + (++nextTreeId)

  @property({ type: Boolean, attribute: 'multiselect' })
  multiple = false;

  @property({type: String})
  source: string|undefined

  constructor() {
    super();
    log('created')
  }
  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    log('firstUpdated')
    this.sync();
  }
  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);
    log('updated')
    this.sync();
  }

  subscription: Subscription|undefined = undefined
  cacheKey = ''
  async sync() {
    const nKey = this.id + '|' + this.source
    log(`sync: ${nKey}`)
    if (!this.id || !this.source) {
      log('missing id or source... skipping')
      return
    }
    if(this.cacheKey === nKey) {
      log('no change... skipping')
      return
    }
    this.cacheKey = nKey
    if (this.subscription) {
      log('unsubscribing from old data')
      this.subscription.unsubscribe();
    }

    log(`upserting tree with source: ${this.source}`)
    dataBroker.upsertDerivation(this.id, [this.source], async (sources: any []) => {
      const [treeData] = sources as [ITreeNode[]]
      console.log('treeData', treeData);
      return new Tree(this.id, treeData, this.multiple)
    })
  }

  render()    {
    if(this.source)
      return nothing //`Source: ${this.source}`
    else
      return `No source specified`
  }
}